import { combineReducers, Reducer } from 'redux';

import * as types from './meeting-tasks.types';
import * as constants from './meeting-tasks.constants';
import { isActionOfType } from '../../../../utils/action.utils';

const initialState: types.IMeetingTasksPageState = {
  meetingTasks: {},
};

const meetingTasksReducer: Reducer<
  types.IMeetingTasksPageState['meetingTasks'],
  types.IStoreMeetingTasks | types.IClearMeetingTasks
> = (state = initialState.meetingTasks, action) => {
  if (isActionOfType<types.IStoreMeetingTasks>(action, constants.STORE_MEETING_TASKS)) {
    return action.payload;
  } else if (isActionOfType<types.IClearMeetingTasks>(action, constants.CLEAR_MEETING_TASKS)) {
    return initialState.meetingTasks;
  }
  return state;
};

export const meetingTasksPageReducer: Reducer<
  types.IMeetingTasksPageState,
  types.IMeetingTasksPageAction
> = combineReducers({
  meetingTasks: meetingTasksReducer,
});
